/**
* @ngdoc component
* @name common.component:itxNaverLogin
* @description
* Naver login for Korea

*/
(function(d) {
    'use strict';
    
     var itxNaverLogin = {
      bindings: {
        onLogin:'&'
      },
      controller:   itxNaverLoginCtrl,
      templateUrl: 'naver-login.component.html'
    };
  
    itxNaverLoginCtrl.$inject = [
      'NaverLoginService',
      'DUTTI_CONS',
      'ItxLoginSvc',
      'NavigationService',
      'CmsConfigSvc',
      'ngDialog',
      'ItxErrorMessagesFct'
    ];
  
    function itxNaverLoginCtrl (
      NaverLoginService,
      DUTTI_CONS,
      ItxLoginSvc,
      NavigationService,
      CmsConfigSvc,
      ngDialog,
      ItxErrorMessagesFct
    ) {
      var _this = this;
      _this.showNaverButton = false;
      _this.naverButtonEnglish = false;
      _this.naverButtonKorean = false;
      
      _this.$onInit = function () {
        CmsConfigSvc.getProperty('naver_login')
        .then(function(res){
          if(res){
            _this.showNaverButton = true;
            _this.checkNaverButton();
            _this.createScriptFile();
          }
        });
  
      };
  
      _this.checkNaverButton = function() {
        // Naver Login button
        inditex.onReady(function() {
          if(_this.showNaverButton){
            if(inditex.iLangId === DUTTI_CONS.languages.EN){
              //_this.naverButton = ItxStaticResourceSvc.getImage('naver_en.png');
              _this.naverButtonEnglish = true;
            } else {
              //_this.naverButton = ItxStaticResourceSvc.getImage('naver_kr.png');
              _this.naverButtonKorean = true;
            }
          }
        });
      };
  
      _this.createScriptFile = function() {
        var js, ref = d.getElementsByTagName('script')[0];
  
        js = d.createElement('script');
        js.onload = _this.initNaver;
        js.id = 'naverScript';
        js.src = "//static.nid.naver.com/js/naveridlogin_js_sdk_2.0.0.js";
  
        ref.parentNode.insertBefore(js, ref);      
      };
  
      _this.initNaver = function(){
        _this.naverLogin = new naver.LoginWithNaverId({
          clientId: "mnLkvBBXqkPwX1O3wJhj",
          callbackUrl: NavigationService.setNaverLink(),
          isPopup: false,
          callbackHandle: true
        });
        _this.naverLogin.init();
        // Attach events
        window.addEventListener('load', function () {
          _this.getNaverLoginStatus();        
        });
  
        $(window).on('message', function(event) {
          var data = event.originalEvent.data;
          
          if(data.naver){
            _this.getNaverLoginStatus();
          }
        });
      };
  
      _this.openPopup = function(){
        window.open(_this.naverLogin.generateAuthorizeUrl(), null,'titlebar=1, resizable=1, scrollbars=yes,width=300,height=400');
      };
  
      _this.getNaverLoginStatus = function(){
        _this.naverLogin.getLoginStatus(function (status) {
  
          console.log('naver logged? ', status);
          /* if(status){
            _this.naverLogin.logout();
          } */
          
          if (status && !ItxLoginSvc.isLogged()) {
            var email = _this.naverLogin.user.getEmail();
  
            if( email == undefined || email == null) {
              //_this.naverLogin.reprompt();
              return;
            }
  
            _this.user = {
              socialToken: _this.naverLogin.accessToken.accessToken,
              socialId: _this.naverLogin.user.id,
              privacyPolicyAccepted: true,
              email: _this.naverLogin.user.email,
              primaryAddress: {
                firstName: _this.naverLogin.user.name,
                lastName: _this.naverLogin.user.name,
                isCompany: false
              },
              socialType:'N'
            };
  
            var data = {
              socialToken: _this.naverLogin.accessToken.accessToken,
              socialId: _this.naverLogin.user.id,
              privacyPolicyAccepted: true,
              email: _this.naverLogin.user.email,
              primaryAddress: {
                firstName: _this.naverLogin.user.name,
                lastName: _this.naverLogin.user.name,
                isCompany: false
              },
              socialType:'N'
            };
            
            if(NaverLoginService.getNaverLoginProcessing() != true){
              _this.socialLogin(data); 
            }   
            // NaverLoginService.login(data)
            // .then(function(){
            //   if (_this.onLogin){
            //     _this.onLogin();
            //   }
            // });
          }
        });
      };
  
      _this.socialLogin = function (user, closeDialog) {
        NaverLoginService.setNaverLoginProcessing(true);
        ItxLoginSvc.socialLogin(user)
            .then(function (userJSON) {
              inditex.iUserJSON = userJSON;
              sessionStorage.setItem("cache-current-user", JSON.stringify(inditex.iUserJSON));
              if(closeDialog) { ngDialog.close(); }
              if (_this.onLogin){ _this.onLogin(); }
  
              _this.addBaseTag();
              NaverLoginService.setNaverLoginProcessing(false);
              _this.naverLogin.logout();
            })
            .catch(function(error){
              _this.addBaseTag();
              switch (error.errorKey) {
                case 'INVALID_SOCIAL_USER_NEED_EMAIL':
                    _this.OpenRegisterAccountDialog();
                    break;
                case '_APP_PERSON_REGISTER':
                    _this.OpenRegisterAccountDialog();
                    break;
                case 'INVALID_SOCIAL_USER_NEED_PASSWORD':
                    _this.OpenLinkAccountDialog();
                    break;
                default:
                    // Generic error
                    ItxErrorMessagesFct.dialog(error.errorMessage);
                    break;
              }
              NaverLoginService.setNaverLoginProcessing(false);
            });
      };
  
      _this.OpenLinkAccountDialog = function() {
        ngDialog.open({
            template: '<itx-social-login-link-account-dialog user="ngDialogData.user" on-continue="ngDialogData.onContinue(user,true)" close-dialog="closeThisDialog()"></itx-social-login-link-account-dialog>',
            plain: true,
            className: 'new-modal ma-modal-md ma-modal-macro ngdialog-theme-plain ',
            showClose: true,
            data: {
                user: _this.user,
                onContinue: _this.socialLogin
            }
        });
      };
  
      _this.OpenRegisterAccountDialog = function() {
          ngDialog.open({
              template: '<itx-social-login-register-account-dialog user="ngDialogData.user" on-continue="ngDialogData.onContinue(user,true)" close-dialog="closeThisDialog()"></itx-social-login-register-account-dialog>',
              plain: true,
              className: 'new-modal ma-modal-md ma-modal-macro ngdialog-theme-plain ',
              showClose: true,
              data: {
                  user: _this.user,
                  onContinue: _this.socialLogin
              }
          });
      };
  
      // Add base tag needed for CMS webcomponent
  
      _this.addBaseTag = function() {
        if(document.getElementById('baseHrefjs') == null){
          var baseHref = document.createElement('base');
          baseHref.href='/';
          baseHref.id='baseHrefjs';
          document.getElementsByTagName('head')[0].appendChild(baseHref);
        }
      };
  
      _this.logout = function(){
        _this.naverLogin.logout();
        location.reload();
      };
  
    }
  
    angular.module('itxApp.common')
    .component('itxNaverLogin',itxNaverLogin);
  
  })(document); // Dont touch this.